import gsap from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useGSAP } from '@gsap/react'

if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger, useGSAP)
    ScrollTrigger.config({ ignoreMobileResize: true })
}

/** Media queries shared by every gsap.matchMedia() block. */
export const MOTION = {
    ok: '(prefers-reduced-motion: no-preference)',
    reduce: '(prefers-reduced-motion: reduce)',
    desktop: '(min-width: 1024px)',
    fine: '(hover: hover) and (pointer: fine)'
}

export const prefersReducedMotion = (): boolean =>
    typeof window !== 'undefined' && window.matchMedia(MOTION.reduce).matches

export { gsap, ScrollTrigger, useGSAP }
